import Header from '@/shared/components/Header';
import Sidebar from '@/shared/components/Sidebar';
import { useInactivityTimeout } from '@/shared/hooks';
import { useState } from 'react';
import { Outlet } from 'react-router';

export default function MainLayout() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  useInactivityTimeout();

  return (
    <div className="min-h-screen bg-background theme-transition">
      <Sidebar
        collapsed={sidebarCollapsed}
        onToggleCollapse={() => setSidebarCollapsed(!sidebarCollapsed)}
      />
      <div className={`${sidebarCollapsed ? 'ml-16' : 'ml-64'} transition-all duration-300`}>
        <Header />
        <main className="h-[calc(100vh-4rem)] overflow-auto bg-background theme-transition p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
